window.initStripe = function(publicKey, clientSecret) {
  var stripe = Stripe(publicKey);

  var elements = stripe.elements();

  var elementStyle = {
    base: {
      fontSize: '16px',
      color: '#32325d',
      '::placeholder': {
        color: '#aab7c4'
      }
    },
    invalid: {
      color: '#fa755a',
      iconColor: '#fa755a'
    }
  };

  var cardNumberElement = elements.create('cardNumber', {
    style: elementStyle,
    placeholder: '0000 0000 0000 0000'
  });

  var cardExpiryElement = elements.create('cardExpiry', {
    style: elementStyle,
    placeholder: 'MM / YY'
  });

  var cardCvcElement = elements.create('cardCvc', {
    style: elementStyle,
    placeholder: '000'
  });

  cardNumberElement.mount('#card-number-element');
  cardExpiryElement.mount('#card-expiry-element');
  cardCvcElement.mount('#card-cvc-element');

  var cardForm = document.getElementById('credit-card-form');
  var stripePaymentMethodId = document.getElementById('stripe_payment_method_id');
  var submitButton = document.getElementById('card-submit-button');

  function handleElementChange(event) {
    if (event.error) {
      showError(event.error.message);
    } else {
      hideError();
    }
  }

  cardNumberElement.on('change', handleElementChange);
  cardExpiryElement.on('change', handleElementChange);
  cardCvcElement.on('change', handleElementChange);

  submitButton.addEventListener('click', function(ev) {
    hideError();
    setStripeSubmit(true);

    stripe.confirmCardSetup(
      clientSecret,
      {
        payment_method: {
          card: cardNumberElement
        }
      }
    ).then(function(result) {
      if (result.error) {
        showError(result.error.message);
        setStripeSubmit(false);
        ev.preventDefault();
        return false;
      } else {
        if (result.setupIntent.status == "succeeded") {
          stripePaymentMethodId.value = result.setupIntent.payment_method;
          hideError();
          Rails.fire(cardForm, 'submit');
        } else {
          setStripeSubmit(false);
          ev.preventDefault();
          showError(result.setupIntent.last_setup_error);
        }
      }
    });
  });
}

window.setStripeSubmit = function(sending = true) {
  if (sending) {
    $("#card-submit-button").prop("disabled", true);
    $('#card-submit-button span').html('Adding...');
  } else {
    $("#card-submit-button").prop("disabled", false);
    $('#card-submit-button span').html('Add');
  }
}

function showError(message) {
  $('#errors').removeClass('d-none');
  $('#errors').html(message);
}

function hideError() {
  $('#payment-method-errors').html('')
  $('#errors').addClass('d-none');
}
